module.exports = __webpack_public_path__ + "static/media/JayLagorio.b003b7ba.jpg";